export function chunk(arr, chunk_size) {
    if (!arr.length) {
        return [[]];
    }
    const results = [];
    const tmpArr = clone(arr);

    while (tmpArr.length) {
        results.push(tmpArr.splice(0, chunk_size));
    }

    return results;
};

export function clone(arr) {
    return arr.slice(0);
}

export default {
    chunk,
    clone
};


// WEBPACK FOOTER //
// ./Assets/Scripts/Util/array.js